module.exports = __webpack_public_path__ + "img/checked.2cc2fc34.svg";